/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { gnoment } from 'shared-ui/gnoment';

type AvailabilityParams = { permitId: string; type: string; year?: string; date: string };

export const API_ROOT = process.env.API || '';

// Permit
export const permit = (id: string) => `${API_ROOT}/permitcontent/${id}`;
export const huntingpermit = (id: string) => `${API_ROOT}/huntingpermit/${id}`;
export const recarea = (recareaId: string) =>
    `${API_ROOT}/search?fq=entity_type%3Arecarea&fq=entity_id%3A${recareaId}`;

// Availability
export const availability = ({ permitId, type, year, date }: AvailabilityParams) =>
    `${huntingpermit(permitId)}/availability?permit_type=${type}&year=${year || gnoment().format('YYYY')}${date ? `&start_date=${date}` : ''}`;

// Reservations
export const reservations = (permitId: string) =>
    `${API_ROOT}/huntingpermit/permit/${permitId}/issuances`;
export const reservation = (permitId: string, reservationId: string) =>
    `${reservations(permitId)}/${reservationId}`;
export const unpaidReservation = (permitId: string, reservationId: string) =>
    `${reservation(permitId, reservationId)}/unpaid`;

export const lotteries = (permitId: string) => `${API_ROOT}/permitlottery/${permitId}`;
export const lottery = (permitId: string, lotteryId: string) =>
    `${API_ROOT}/permitlottery/${permitId}/single/${lotteryId}`;

// Lottery Application
export const lotteryIssuance = () => `${API_ROOT}/huntingpermit/lottery/issuances`;
export const updLotteryIssuance = (reservationId: string) =>
    `${API_ROOT}/huntingpermit/lottery/issuances/${reservationId}`;
export const unpaidLotteryIssuance = (
    permitId: string,
    reservationId: string,
    useNewMuxPath = false
) =>
    useNewMuxPath
        ? `${API_ROOT}/huntingpermit/permit/${permitId}/lottery/issuances/${reservationId}/unpaid`
        : `${API_ROOT}/huntingpermit/${permitId}/lottery/issuances/${reservationId}/unpaid`;
export const getLotteryIssuance = (permitId: string, reservationId: string) =>
    `${API_ROOT}/permitissuance/${permitId}/issuances/${reservationId}`;
export const cancelIssuance = (
    permitId: string,
    issuanceId: string,
    useNewMuxPath = false
) =>
    useNewMuxPath
        ? `${API_ROOT}/huntingpermit/permit/${permitId}/lottery/issuances/${issuanceId}/cancel`
        : `${API_ROOT}/huntingpermit/${permitId}/lottery/issuances/${issuanceId}/cancel`;
export const lotteryIssuanceWinner = (
    permitId: string,
    reservationId: string,
    useNewMuxPath = false
) =>
    useNewMuxPath
        ? `${API_ROOT}/huntingpermit/permit/${permitId}/lottery/issuances/${reservationId}/accepted`
        : `${API_ROOT}/huntingpermit/${permitId}/lottery/issuances/${reservationId}/accepted`;

// Seasons
export const seasons = ({
    currentDate,
    permitId,
}: {
    currentDate: any;
    permitId: string;
}) => `${API_ROOT}/permitseason/display/${permitId}/${currentDate}`;
